import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    personalai: [],
    isLoading: true,
    error: null,
};

const personalaiSlice = createSlice({
    name: "personalai",
    initialState,
    reducers: {
        getPersonalAISuccess: (state, action) => {
            state.personalai = [...state.personalai.filter(ele => !ele.score), ...action.payload];
            state.isLoading = false;
            state.error = null;
        },
        getPersonalAIFailure: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        },
        deletePersonalAISuccess: (state, action) => {
            state.personalai = state.personalai.filter(
                (item) => item._id !== action.payload
            );
        },
        addSinglePersonalAISuccess: (state, action) => {
            state.personalai = [action.payload, ...state.personalai];
        },
        updateSinglePersonalAISuccess: (state, action) => {
            state.personalai = state.personalai.map((item) =>
                item._id === action.payload.id || item.id === action.payload.id  ? action.payload.data : item
            );
        },
    },
});

export const {
    getPersonalAISuccess,
    getPersonalAIFailure,
    deletePersonalAISuccess,
    addSinglePersonalAISuccess,
    updateSinglePersonalAISuccess,
} = personalaiSlice.actions;

export default personalaiSlice.reducer;